import Button, { Color, Size } from 'lib/Button';

export type SecondaryPanelActionsProps = {
  cancelButtonLabel: string;
  confirmButtonLabel: string;
  confirmButtonColor: Color;
  isDisabled: boolean;
  onCancel: VoidFunction;
  onSubmit: VoidFunction;
  pendoId?: string;
  getPendoDataId: (id: string) => string;
};

export const SecondaryPanelActions = ({
  cancelButtonLabel,
  confirmButtonLabel,
  confirmButtonColor,
  isDisabled,
  onCancel,
  onSubmit,
  pendoId,
  getPendoDataId,
}: SecondaryPanelActionsProps): React.ReactElement => (
  <div
    data-test-id="planner-secondary-panel-actions"
    className="flex justify-between w-full border-t border-gray-200 p-2"
  >
    <Button label={cancelButtonLabel} size={Size.MEDIUM} color={Color.TERTIARY} onClick={onCancel} />
    <Button
      label={confirmButtonLabel}
      size={Size.MEDIUM}
      color={confirmButtonColor}
      onClick={onSubmit}
      isDisabled={isDisabled}
      dataPendoId={pendoId ? getPendoDataId(`${pendoId} confirm button`) : undefined}
    />
  </div>
);
